// eslint-disable-next-line unicorn/prevent-abbreviations
import template from './dev4.html';
import controller from './dev4.controller';
import './dev4.scss';

export default {
	template,
	controller,
	title: 'dev4',
	path: '/dev4',
	onlyDev: true,
	controllerAs: '$ctrl',
};
